import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = {
  autocomplete: "off",
  class: "flex flex-col gap-4"
}
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_9 = { class: "mt-4 grid grid-cols-2 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["UiRightPanel"], {
    modelValue: $setup.filtersOpened,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filtersOpened) = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode($setup["UiButton"], {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filtersOpened = true))
      }, {
        default: _withCtx(() => [
          _createVNode($setup["FilterIcon"], {
            class: "mr-0 h-5 w-5 text-gray-400 sm:mr-3",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('core.actions.Filter')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('aura.processingCosts.filters.userLabel')), 1 /* TEXT */),
          _createVNode($setup["UiMultiselect"], {
            name: "processing_costs_user",
            "model-value": $props.modelValue.userId,
            options: $props.users,
            label: "name",
            "value-prop": "id",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.update({ userId: $event || undefined })))
          }, null, 8 /* PROPS */, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('aura.processingCosts.filters.typeLabel')), 1 /* TEXT */),
          _createVNode($setup["UiMultiselect"], {
            name: "processing_costs_type",
            "model-value": $props.modelValue.processingType,
            options: $setup.typeOptions,
            label: "label",
            "value-prop": "value",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.update({ processingType: $event || undefined })))
          }, null, 8 /* PROPS */, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('aura.processingCosts.filters.statusLabel')), 1 /* TEXT */),
          _createVNode($setup["UiMultiselect"], {
            name: "processing_costs_status",
            "model-value": $props.modelValue.status,
            options: $setup.statusOptions,
            label: "label",
            "value-prop": "value",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.update({ status: $event || undefined })))
          }, null, 8 /* PROPS */, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode($setup["UiButton"], {
            variant: "white",
            "text-variant": "gray-700",
            onClick: $setup.clearFilters
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode($setup["UiButton"], {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.filtersOpened = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title"]))
}